export default "__VITE_ASSET__DCwiKM5H__"